import script from "./DashboardPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardPage.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardPage.vue?vue&type=style&index=0&id=57ba63b2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57ba63b2"]])

export default __exports__